import { render, staticRenderFns } from "./BadDebt.vue?vue&type=template&id=695485cb"
import script from "./BadDebt.vue?vue&type=script&lang=js"
export * from "./BadDebt.vue?vue&type=script&lang=js"
import style0 from "./BadDebt.vue?vue&type=style&index=0&id=695485cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports